import { connect } from 'react-redux';
import { userRegistrationBegin } from 'store/actions/auth.actions';
import UploadProfile from 'views/register/uploadProfile/UploadProfile';

const mapDispatchToProps = { userRegistrationRequest: userRegistrationBegin};

export default connect(null, mapDispatchToProps)(UploadProfile);